const joinArrayWith = (array: string[], join: string) => {
    const lastItem = array.pop();

    if (array.length === 0) {
        return lastItem;
    }

    return `${array.join(', ')} ${join} ${lastItem}`;
};

export default joinArrayWith;
